const eq = require('./eq')
const ne = require('./ne')
const gte = require('./gte')
const lte = require('./lte')
const contains = require('./contains')
const noContains = require('./no-contains')
module.exports = {
  $ne: ne,
  $eq: eq,
  $gte: gte,
  $lte: lte,
  contains: contains,
  'no-contains': noContains
}
